import axios from 'axios';
import { FETCH_ALL_CATEGORIES } from '../actionTypes';
export const fetch = blockId => dispatch => {
	return new Promise((respond, rej) => {
		axios.get('categories').then(res => {
			dispatch({
				type: FETCH_ALL_CATEGORIES,
				payload: res.data,
			});

			respond();
		});
	});
};

export const create = data => dispatch => {
	return new Promise((respond, rej) => {
		axios.post('categories', data).then(res => {
			dispatch({
				type: FETCH_ALL_CATEGORIES,
				payload: {
					[res.data.id]: res.data,
				},
			});

			respond();
		});
	});
};

export const update = data => dispatch => {
	return new Promise((respond, rej) => {
		axios.patch(`categories/${data.id}`, data).then(response => {
			dispatch({
				type: FETCH_ALL_CATEGORIES,
				payload: {
					[response.data.id]: response.data,
				},
			});
			respond();
		});
	});
};



// WEBPACK FOOTER //
// ./src/store/actions/categories.js